export type ShareGrantCap = {
  max_rank: number
  max_permission: 'view' | 'edit' | 'full' | null
  allow_full: boolean
  allow_edit: boolean
  allow_view: boolean
  allow_downloadable: boolean
}

export const PERMISSION_OPTIONS = [
  { value: 'view' as const, label: '查看' },
  { value: 'edit' as const, label: '编辑' },
  { value: 'full' as const, label: '完全控制' },
]

export function permissionOptionsForCap(cap: ShareGrantCap | null) {
  if (!cap) return PERMISSION_OPTIONS
  return PERMISSION_OPTIONS.filter((opt) => {
    if (opt.value === 'view') return cap.allow_view
    if (opt.value === 'edit') return cap.allow_edit
    return cap.allow_full
  })
}

export function clampSharePermission(
  permission: 'view' | 'edit' | 'full',
  downloadable: boolean,
  cap: ShareGrantCap | null,
): { permission: 'view' | 'edit' | 'full'; downloadable: boolean } {
  if (!cap) return { permission, downloadable }
  const allowed = permissionOptionsForCap(cap)
  let nextPermission = allowed.some((o) => o.value === permission)
    ? permission
    : allowed[allowed.length - 1]?.value ?? 'view'
  if (nextPermission === 'edit' || nextPermission === 'full') {
    return { permission: nextPermission, downloadable: false }
  }
  let nextDownloadable = downloadable
  if (!cap.allow_downloadable) {
    nextDownloadable = false
  }
  return { permission: nextPermission, downloadable: nextDownloadable }
}
